<template>
  <b-container fluid>
    <b-row class="details">
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                  <!-- <b-row>
                        <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                            <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                        </b-col>
                    </b-row> -->
                    <b-row>
                        <b-col v-if="Object.keys(detailsFormData).length > 0" xl="12" lg="12" sm="12">
                            <b-table-simple striped bordered small hover>
                                <tbody>
                                    <b-tr>
                                        <b-td>{{ $t('globalTrans.fiscalYear') }}</b-td>
                                        <b-td>{{ ($i18n.locale === 'bn' ? detailsFormData.fiscal_year_bn : detailsFormData.fiscal_year_en) }}</b-td>
                                        <b-td>{{ $t('grant_process.circular_id') }}</b-td>
                                        <b-td>{{ detailsFormData.auto_id }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{ $t('globalTrans.title') }}</b-td>
                                        <b-td colspan="3">{{ ($i18n.locale === 'bn' ? detailsFormData.title_bn : detailsFormData.title_en) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{ $t('globalTrans.description') }}</b-td>
                                        <b-td colspan="3">{{ ($i18n.locale === 'bn' ? detailsFormData.description_bn : detailsFormData.description_en) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{ $t('grant_process.deadline') }}</b-td>
                                        <b-td>{{ detailsFormData.deadline | dateFormat }}</b-td>
                                        <b-td>{{ $t('globalTrans.attachment') }}</b-td>
                                        <b-td>
                                            <span v-if="detailsFormData.attachment">
                                            <a :href="url + 'download-attachment?file=' + 'uploads/admin/circular/original' + '/'
                                                + detailsFormData.attachment" target="_blank" rel="noopener noreferrer">
                                                <!-- {{ detailsFormData.attachment }} -->
                                                <span class="badge badge-success">
                                                    {{$t('globalTrans.download')}} <i class="ri-download-cloud-line" ></i>
                                                </span>
                                            </a>
                                            </span>
                                        </b-td>
                                    </b-tr>
                                </tbody>
                            </b-table-simple>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-5')">{{ $t('globalTrans.close') }}</b-button>
                                </div>
                            </div>
                            <!-- <pre>{{detailsFormData}}</pre> -->
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { grantAllowanceServiceBaseUrl } from '@/config/api_config'
export default {
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getInstituteInfoData()
            this.detailsFormData = tmp
        }
    },
    mounted () {
        // core.index()
    },
    data () {
        return {
            detailsFormData: {},
            url: grantAllowanceServiceBaseUrl
        }
    },
    computed: {
       currentLocale () {
      return this.$i18n.locale
    }
    },
    methods: {
        getInstituteInfoData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        }
    }
}

</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
